import styled from 'styled-components';

import { colors, fonts, metrics } from '@/theme';

export const StyledButton = styled.button`
  ${fonts.getRegularText()}
  height: 40px;
  border: none;
  border-radius: 20px;
  background: ${colors.tag.normal};
  padding: 0 15px 4px 15px;
  color: ${colors.white};
  width: ${({ width }) => (width || 'auto')};
  transition: background .5s;
  :hover {
    cursor: pointer;
    background: ${colors.tag.hover};
  }
  :focus {
    outline: 0;
  }
  :active {
    outline: 0;
    background: ${colors.tag.active};
  }
  @media (max-width: ${metrics.mobile}px) {
    height: 32px;
    border-radius: 16px;
    padding-bottom: 2px;
  }
`;
